import React, {Fragment, useContext, useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import ErrorMessage from 'app/React/Components/misc/ErrorMessage'
import { SuperSelect } from 'app/React/Components/Form/SuperSelect'
import Tip from 'app/React/Components/misc/Tip'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";
import classNames from "classnames";

export default function LocationField(props) {
  const {
    isAccessoryShop,
    isStorageOrderHandled,
    locations,
    order,
    useSelectForDealers,
    setOrder,
    defaultValidateSteps,
  } = useContext(ConfiguratorContext)

  const [location, setLocation] = useState(null)
  const postnumber_address = order.postnumber_address ?? ''

  useEffect(() => {
    let firstSelectedLocation = null

    if (Object.keys(locations).length === 1) {
      firstSelectedLocation = Object.keys(locations)[0]
    } else {
      firstSelectedLocation = order.pickup_location ?? ''
    }

    order.pickup_location = firstSelectedLocation
    setOrder({ ...order })

    setLocation(firstSelectedLocation)
  }, [])

  if (
    (!isAccessoryShop && isStorageOrderHandled !== true) ||
    location === null
  ) {
    return null
  }

  const onchange = function (value) {
    order.pickup_location = value
    setOrder({ ...order })

    defaultValidateSteps()
  }

  function LocationList(locations) {
    const locationsLength = Object.keys(locations).length

    return Object.keys(locations).map((key) => (
      <Fragment key={key}>
        <input
          onChange={() => onchange(key)}
          type='radio'
          name='pickup_location'
          id={'paymentradio_location_' + locations[key]}
          value={key}
          defaultChecked={location === key}
        />
        <label
          htmlFor={'paymentradio_location_' + locations[key]}
          className={classNames('config-radio__radio', {
            'config-radio__radio--full-width': !useSelectForDealers && locationsLength <= 1,
          })}
          layout='standard'
          dangerouslySetInnerHTML={{ __html: locations[key] }}
        />
      </Fragment>
    ))
  }

  const locations1 = Object.entries(locations).map(([key, val]) => ({ ...val, id: key }))

  const locations2 = Object.fromEntries(
    Object.entries(locations).map(([key, val]) => [key, typeof val === 'string' ? val : val.title])
  )

  /**
   * @param {{id:string,title:string,zipcodes:string[]}[]} locations1
   * @param {string} searchterm
   */
  function getDefaultLocationfromZip(locations1, searchterm) {
    return locations1?.find((x) => searchterm && x.zipcodes?.includes(searchterm)) ?? null
  }

  const location_elements = useSelectForDealers ? (
    <SuperSelect
      defaultValue={getDefaultLocationfromZip(locations1, postnumber_address)}
      onChange={(value) => onchange(value?.id)}
      locations={locations1}
      location={locations[location] ? { ...locations[location], id: location } : null}
    />
  ) : (
    LocationList(locations2)
  )

  return (
    <>
      <h2 className='config-form__subtitle'>
        {props.title}
        {typeof props.tip === 'string' && props.tip.length > 0 ? <Tip content={props.tip}/> : null}
      </h2>

      <div className='config-radio'>{location_elements}</div>
      <ErrorMessage field='pickup_location'/>
      <div className='config-form__separator'/>
    </>
  )
}

LocationField.propTypes = {
  title: PropTypes.string
}
